module.exports = __webpack_public_path__ + "media/images/wcmc_components-9d4ecb370feed2a807cf13a91de58dd7.svg";